// About 组件 - 关于页面
import React, { useState } from 'react';
import './index.css';

const About = () => {
  const [activeTab, setActiveTab] = useState('about');

  // 技能数据
  const skills = [
    { name: 'React', level: 90 },
    { name: 'JavaScript', level: 85 },
    { name: 'HTML/CSS', level: 95 },
    { name: 'Node.js', level: 80 },
    { name: 'Vue.js', level: 75 },
    { name: 'TypeScript', level: 80 },
    { name: 'Python', level: 70 },
    { name: 'Git', level: 85 }
  ];

  // 工作经历数据
  const experiences = [
    {
      id: 1,
      company: '科技有限公司',
      position: '高级前端工程师',
      period: '2022年1月 - 至今',
      description: '负责大型Web应用的前端架构设计和开发，带领团队完成多个重要项目。',
      achievements: [
        '主导重构公司核心产品，性能提升40%',
        '建立前端组件库，提高开发效率30%',
        '推动团队采用新技术栈，提升代码质量'
      ]
    },
    {
      id: 2,
      company: '创新网络科技',
      position: '前端工程师',
      period: '2020年3月 - 2021年12月',
      description: '参与多个客户项目的前端开发工作，负责界面实现和交互优化。',
      achievements: [
        '独立完成5个企业级项目的前端开发',
        '优化页面加载速度，平均提升35%',
        '协助团队建立代码规范和CI/CD流程'
      ]
    },
    {
      id: 3,
      company: '软件开发工作室',
      position: '初级前端工程师',
      period: '2019年6月 - 2020年2月',
      description: '参与小型项目开发，积累前端开发经验，学习团队协作。',
      achievements: [
        '完成10+个网站的前端开发',
        '掌握React和Vue框架的核心概念',
        '获得团队优秀新人奖'
      ]
    }
  ];

  // 教育背景数据
  const education = [
    {
      id: 1,
      school: '某某大学',
      degree: '计算机科学与技术学士',
      period: '2015年9月 - 2019年6月',
      description: '主修课程：数据结构、算法设计、数据库原理、计算机网络等'
    },
    {
      id: 2,
      school: '在线技术学院',
      degree: '前端开发专项课程',
      period: '2018年3月 - 2018年9月',
      description: '深入学习现代前端技术栈，包括React、Vue等框架'
    }
  ];

  return (
    <div className="about-container">
      {/* 个人简介头部 */}
      <section className="about-header">
        <div className="profile-image">
          <img src="https://via.placeholder.com/150" alt="个人头像" />
        </div>
        <div className="profile-info">
          <h1>张三</h1>
          <h2>前端开发工程师</h2>
          <p className="bio">
            热爱技术分享的前端开发者，专注于React和Vue技术栈，拥有5年前端开发经验。
            喜欢探索新技术，乐于帮助他人解决问题，致力于创造优秀的用户体验。
          </p>
          <div className="contact-info">
            <div className="contact-item">
              <span className="icon">📧</span>
              <span>zhangsan@example.com</span>
            </div>
            <div className="contact-item">
              <span className="icon">📍</span>
              <span>北京市朝阳区</span>
            </div>
            <div className="contact-item">
              <span className="icon">🌐</span>
              <span>www.myblog.com</span>
            </div>
          </div>
          <div className="social-links">
            <a href="#!" className="social-link">
              <span className="icon">🐙</span>
              <span>GitHub</span>
            </a>
            <a href="#!" className="social-link">
              <span className="icon">💼</span>
              <span>LinkedIn</span>
            </a>
            <a href="#!" className="social-link">
              <span className="icon">🐦</span>
              <span>Twitter</span>
            </a>
          </div>
        </div>
      </section>

      {/* 导航标签 */}
      <section className="about-tabs">
        <div className="tabs-container">
          <button 
            className={`tab ${activeTab === 'about' ? 'active' : ''}`}
            onClick={() => setActiveTab('about')}
          >
            关于我
          </button>
          <button 
            className={`tab ${activeTab === 'skills' ? 'active' : ''}`}
            onClick={() => setActiveTab('skills')}
          >
            技能
          </button>
          <button 
            className={`tab ${activeTab === 'experience' ? 'active' : ''}`}
            onClick={() => setActiveTab('experience')}
          >
            工作经历
          </button>
          <button 
            className={`tab ${activeTab === 'education' ? 'active' : ''}`}
            onClick={() => setActiveTab('education')}
          >
            教育背景
          </button>
        </div>
      </section>

      {/* 内容区域 */}
      <section className="about-content">
        {activeTab === 'about' && (
          <div className="content-section">
            <h2>关于我</h2>
            <div className="about-text">
              <p>
                我是一名拥有5年前端开发经验的工程师，专注于创建高质量的Web应用程序。
                我对技术充满热情，喜欢解决复杂问题，并且总是渴望学习新的技术和方法。
              </p>
              <p>
                在我的职业生涯中，我有幸参与了许多有趣的项目，从小型创业公司的产品到大型企业的关键系统。
                这些经历不仅提升了我的技术能力，也让我学会了如何在团队中有效沟通和协作。
              </p>
              <p>
                除了工作，我还热衷于技术分享。我经常在我的博客上撰写技术文章，
                并在技术社区中积极参与讨论。我相信知识分享能够帮助整个社区进步，
                同时也能让自己不断成长。
              </p>
              <p>
                在业余时间，我喜欢阅读技术书籍、参加技术会议，也会做一些开源项目贡献。
                我相信持续学习是技术人员最重要的品质之一。
              </p>
            </div>
            
            <div className="interests">
              <h3>兴趣爱好</h3>
              <div className="interests-grid">
                <div className="interest-item">
                  <span className="icon">📚</span>
                  <span>阅读技术书籍</span>
                </div>
                <div className="interest-item">
                  <span className="icon">🚴</span>
                  <span>骑行</span>
                </div>
                <div className="interest-item">
                  <span className="icon">📷</span>
                  <span>摄影</span>
                </div>
                <div className="interest-item">
                  <span className="icon">🎵</span>
                  <span>音乐</span>
                </div>
              </div>
            </div>
          </div>
        )}

        {activeTab === 'skills' && (
          <div className="content-section">
            <h2>技能</h2>
            <div className="skills-container">
              {skills.map((skill, index) => (
                <div key={index} className="skill-item">
                  <div className="skill-header">
                    <span className="skill-name">{skill.name}</span>
                    <span className="skill-level">{skill.level}%</span>
                  </div>
                  <div className="skill-bar">
                    <div 
                      className="skill-progress"
                      style={{ width: `${skill.level}%` }}
                    ></div>
                  </div>
                </div>
              ))}
            </div>
            
            <div className="additional-skills">
              <h3>其他技能</h3>
              <div className="skills-tags">
                <span className="skill-tag">Webpack</span>
                <span className="skill-tag">Redux</span>
                <span className="skill-tag">VueX</span>
                <span className="skill-tag">Sass/Less</span>
                <span className="skill-tag">Bootstrap</span>
                <span className="skill-tag">Ant Design</span>
                <span className="skill-tag">Element UI</span>
                <span className="skill-tag">Jest</span>
                <span className="skill-tag">Cypress</span>
                <span className="skill-tag">Docker</span>
                <span className="skill-tag">Nginx</span>
                <span className="skill-tag">RESTful API</span>
              </div>
            </div>
          </div>
        )}

        {activeTab === 'experience' && (
          <div className="content-section">
            <h2>工作经历</h2>
            <div className="timeline">
              {experiences.map((exp, index) => (
                <div key={exp.id} className="timeline-item">
                  <div className="timeline-marker">
                    <div className="marker-dot"></div>
                    {index !== experiences.length - 1 && <div className="marker-line"></div>}
                  </div>
                  <div className="timeline-content">
                    <div className="experience-header">
                      <h3>{exp.position}</h3>
                      <span className="company">{exp.company}</span>
                    </div>
                    <div className="period">{exp.period}</div>
                    <p className="description">{exp.description}</p>
                    <div className="achievements">
                      <h4>主要成就:</h4>
                      <ul>
                        {exp.achievements.map((achievement, idx) => (
                          <li key={idx}>{achievement}</li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {activeTab === 'education' && (
          <div className="content-section">
            <h2>教育背景</h2>
            <div className="education-list">
              {education.map(edu => (
                <div key={edu.id} className="education-item">
                  <div className="education-header">
                    <h3>{edu.degree}</h3>
                    <span className="school">{edu.school}</span>
                  </div>
                  <div className="period">{edu.period}</div>
                  <p className="description">{edu.description}</p>
                </div>
              ))}
            </div>
            
            <div className="certifications">
              <h3>专业认证</h3>
              <div className="certification-list">
                <div className="certification-item">
                  <h4>Google Developer Certification</h4>
                  <div className="period">2021年5月</div>
                  <p>认证的前端开发专家</p>
                </div>
                <div className="certification-item">
                  <h4>AWS Certified Developer</h4>
                  <div className="period">2020年8月</div>
                  <p>亚马逊云开发人员认证</p>
                </div>
              </div>
            </div>
          </div>
        )}
      </section>

      {/* 联系方式卡片 */}
      <section className="contact-card">
        <h2>联系我</h2>
        <p>如果您有任何问题或想与我合作，欢迎随时联系我！</p>
        <div className="contact-actions">
          <a href="mailto:zhangsan@example.com" className="contact-button primary">
            发送邮件
          </a>
          <a href="#!" className="contact-button secondary">
            下载简历
          </a>
        </div>
      </section>
    </div>
  );
};

export default About;